import { toast } from "react-toastify";

import {
  BRING_YOUR_OWN_DATA_IMPORT_SUCCESS_TOAST_ID,
  BRING_YOUR_OWN_DATA_IMPORT_SUCCESS_TOUR_ID,
  BRING_YOUR_OWN_DATA_MOCKS,
  BRING_YOUR_OWN_DATA_SPATIAL_AGGREGATION_POINT_TOUR_ID
} from "@/components/onboarding/configs/bring-your-own-data.mocks";
import { showToast } from "@/hooks/ui/useToast";
import { showSuccessfulParsingStatusToast } from "@/hooks/useParsingStatus";

// Scoped to the wrapper DataSettingPopup renders around its geometry-setting
// section — the popup's country dropdown uses the same trigger markup, so the
// selector must not match document-wide.
const getSpatialAggregationTriggerSelector = (tourId: string) =>
  `[data-tourid="${tourId}"] button[aria-haspopup="listbox"]`;

const getSpatialAggregationTrigger = (tourId: string) =>
  document.querySelector<HTMLElement>(
    getSpatialAggregationTriggerSelector(tourId)
  );

const closeSpatialAggregationOptions = (trigger: HTMLElement | null) => {
  if (trigger?.getAttribute("aria-expanded") === "true") trigger.click();
};

export const closeSpatialAggregationOptionsWhenReady = (tourId: string) => {
  const scheduleClose = () => {
    const trigger = getSpatialAggregationTrigger(tourId);
    if (!trigger) return false;

    // The tour renders its Data Settings popup without an entrance animation,
    // so the trigger is ready to close as soon as it mounts.
    closeSpatialAggregationOptions(trigger);
    return true;
  };

  if (scheduleClose()) return;

  const observer = new MutationObserver(() => {
    if (!scheduleClose()) return;

    observer.disconnect();
  });

  const timeoutId = window.setTimeout(() => {
    observer.disconnect();
  }, 5000);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  return () => {
    window.clearTimeout(timeoutId);
    observer.disconnect();
  };
};

export const closeSpatialAggregationPointOptions = () => {
  closeSpatialAggregationOptions(
    getSpatialAggregationTrigger(
      BRING_YOUR_OWN_DATA_SPATIAL_AGGREGATION_POINT_TOUR_ID
    )
  );
};

export const closeSpatialAggregationPointOptionsWhenReady = () =>
  closeSpatialAggregationOptionsWhenReady(
    BRING_YOUR_OWN_DATA_SPATIAL_AGGREGATION_POINT_TOUR_ID
  );

export const showImportNewSuccessToast = () => {
  showSuccessfulParsingStatusToast({
    showToast,
    operation: BRING_YOUR_OWN_DATA_MOCKS.importNewOperation,
    autoClose: false,
    toastId: BRING_YOUR_OWN_DATA_IMPORT_SUCCESS_TOAST_ID,
    tourId: BRING_YOUR_OWN_DATA_IMPORT_SUCCESS_TOUR_ID,
    disableAnimation: true
  });

  return () => {
    toast.dismiss(BRING_YOUR_OWN_DATA_IMPORT_SUCCESS_TOAST_ID);
  };
};
